import React from "react";
import error from "../../images/404-error.png";
import { CenterWrapper } from "../../components/error/error.components";

const NotFound = () => {
  return (
    <>
      <CenterWrapper>
        <h1>Not Found</h1>
        <img src={error} alt="404"/>
      </CenterWrapper>
    </>
  );
};

export default NotFound;
